import { useDispatchTool, useStateTool } from 'app/store/withDevTools';
import React from 'react';
import { ContratoReducer, ContratosInitState } from './ContratoReducer';

const ContratoContext = React.createContext();
const ContratoDispatcher = React.createContext();

const ContratoProvider = (props) => {
  const [state, dispatch] = React.useReducer(ContratoReducer, ContratosInitState);

  return (
    <ContratoContext.Provider value={state}>
      <ContratoDispatcher.Provider value={dispatch}>{props.children}</ContratoDispatcher.Provider>
    </ContratoContext.Provider>
  );
};

function ContratoConsumer({ children }) {
  return (
    <ContratoContext.Consumer>
      {(context) => {
        if (context === undefined) {
          throw new Error('ContratoConsumer must be used within a ContratoProvider');
        }

        return children(context);
      }}
    </ContratoContext.Consumer>
  );
}

function useContrato() {
  return [useStateTool(ContratoContext, 'ContratoContext'), useDispatchTool(ContratoDispatcher, 'ContratoDispatcher')];
}

export { ContratoProvider, ContratoConsumer, useContrato };
